
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MachineComponent } from './machine/machine.component';
import { RouterModule } from '@angular/router';
import { StatusComponent } from './status/status.component';
import { FormsModule } from '@angular/forms';
import { ModuleComponent } from './module/module.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MachinetypeComponent } from './machinetype/machinetype.component';
import { TicketviewComponent } from './ticketview/ticketview.component';
import { TicketComponent } from './ticket/ticket.component';
import { CommentComponent } from './comment/comment.component';
import { UserComponent } from './user/user.component';
import { AuthenticateComponent } from './authenticate/authenticate.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { AlertComponent } from './_directives/alert.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { AttachmentComponent } from './attachment/attachment.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { TicketCreateComponent } from './ticket-create/ticket-create.component';
import { ClientComponent } from './client/client.component';
import { ReadComponent } from './read/read.component';
import { RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StateComponent } from './state/state.component';
import { LocationComponent } from './location/location.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ReversePipe } from './comment/reversePipe';
import { ChartsModule } from 'ng2-charts';
import { ClientviewComponent } from './clientview/clientview.component';
import {  DatePipe } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { MachineslistviewComponent } from './machineslistview/machineslistview.component';
import { TruncatePipe } from './_services/truncate';
import { MaintenancelistviewComponent } from './maintenancelistview/maintenancelistview.component';
import { MaintenanceCreateComponent } from './maintenance-create/maintenance-create.component';
import { SatComponent } from './sat/sat.component';
import { SatlistviewComponent } from './satlistview/satlistview.component';
import { DispatchOrderComponent } from './dispatch-order/dispatch-order.component';
import { DispatchTrackingComponent } from './dispatch-tracking/dispatch-tracking.component';
import { DispatchTrackingListviewComponent } from './dispatch-tracking-listview/dispatch-tracking-listview.component';
import { DispatchOrderListviewComponent } from './dispatch-order-listview/dispatch-order-listview.component';
import { DispatchOrderCreateComponent } from './dispatch-order-create/dispatch-order-create.component';
import { DispatchStateComponent } from './dispatch-state/dispatch-state.component';
import { TrackingComponent } from './tracking/tracking.component';
import { TrackinglistviewComponent } from './trackinglistview/trackinglistview.component';
import { TrackingstateComponent } from './trackingstate/trackingstate.component';
import { ClientcreateComponent } from './clientcreate/clientcreate.component';
import { MachinecreateComponent } from './machinecreate/machinecreate.component';
import { FixcatComponent } from './fixcat/fixcat.component';
import { RepairreportComponent } from './repairreport/repairreport.component';
import { ClientreportComponent } from './clientreport/clientreport.component';
import { LogeventComponent } from './logevent/logevent.component';
import { LogeventlistviewComponent } from './logeventlistview/logeventlistview.component';
import { DispatchitemComponent } from './dispatchitem/dispatchitem.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BossfncComponent } from './bossfnc/bossfnc.component';


@NgModule({
  declarations: [
    AppComponent,
    MachineComponent,
    StatusComponent,
    ModuleComponent,
    MachinetypeComponent,
    TicketviewComponent,
    TicketComponent,
    CommentComponent,
    UserComponent,
    AuthenticateComponent,
    LoginComponent,
    HomeComponent,
    NavbarComponent,
    FooterComponent,
    AttachmentComponent,
    UserProfileComponent,
    TicketCreateComponent,
    ClientComponent,
    ReadComponent,
    StateComponent,
    LocationComponent,
    MaintenanceComponent,
    DashboardComponent,
    AlertComponent,
    ReversePipe,
    ClientviewComponent,
    MachineslistviewComponent,
    TruncatePipe,
    MaintenancelistviewComponent,
    MaintenanceCreateComponent,
    SatComponent,
    SatlistviewComponent,
    DispatchOrderComponent,
    DispatchTrackingComponent,
    DispatchTrackingListviewComponent,
    DispatchOrderListviewComponent,
    DispatchOrderCreateComponent,
    DispatchStateComponent,
    TrackingComponent,
    TrackinglistviewComponent,
    TrackingstateComponent,
    ClientcreateComponent,
    MachinecreateComponent,
    FixcatComponent,
    RepairreportComponent,
    ClientreportComponent,
    LogeventComponent,
    LogeventlistviewComponent,
    DispatchitemComponent,
    BossfncComponent,
    
    
       
  ],
  
  imports: [
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    MatFormFieldModule,
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgxPaginationModule,
    NgbModule,
    RichTextEditorModule,
    ReactiveFormsModule,
    DeviceDetectorModule.forRoot(),
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    // AngularFontAwesomeModule,
    CKEditorModule,
    BrowserAnimationsModule,
    ChartsModule, 
    RouterModule,
    
  ],
  exports: [UserComponent],
  providers: [DatePipe, TruncatePipe],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  

})
export class AppModule { }
